import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LoginPage.css';

const logoUrl = process.env.PUBLIC_URL + '/connect-lane-logo.png';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [step, setStep] = useState('credentials'); // 'credentials' | 'otp'
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const navigate = useNavigate();

  const handleCredentialsSubmit = (e) => {
    e.preventDefault();
    if (email && password) {
      setStep('otp');
    } else {
      alert('Please enter email and password');
    }
  };

  const handleOtpChange = (index, value) => {
    if (value.length > 1) {
      const digits = value.replace(/\D/g, '').slice(0, 6).split('');
      const next = [...otp];
      digits.forEach((d, i) => { if (index + i < 6) next[index + i] = d; });
      setOtp(next);
      const lastInput = document.getElementById(`otp-${Math.min(index + digits.length, 5)}`);
      if (lastInput) lastInput.focus();
      return;
    }
    const digit = value.replace(/\D/g, '').slice(-1);
    const next = [...otp];
    next[index] = digit;
    setOtp(next);
    if (digit && index < 5) document.getElementById(`otp-${index + 1}`)?.focus();
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    const code = otp.join('');
    if (code.length !== 6) {
      alert('Please enter the 6 digit OTP');
      return;
    }
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('userEmail', email);
    if (!localStorage.getItem('userName')) {
      localStorage.setItem('userName', 'Viren Shah');
    }
    navigate('/dashboard');
  };

  return (
    <div className="login-page">
      <header className="login-header">
        <Link to="/" className="logo-link">
          <div className="logo-container">
            <img src={logoUrl} alt="Connect Lane" className="logo-img" />
            <span className="logo-text"><span className="logo-connect">Connect</span> <span className="logo-lane">Lane</span></span>
          </div>
        </Link>
        <Link to="/" className="back-link">
          <span className="back-icon">?</span>
          <span>Back to home</span>
        </Link>
      </header>

      <div className="login-container">
        <div className="login-left">
          <div className="secure-badge">
            <span className="badge-icon">🛡️</span>
            <span>SECURE & REGULATED</span>
          </div>
          
          <h1 className="welcome-title">Welcome back to Global Transfers.</h1>
          
          <p className="welcome-description">
            Secure bank-grade encryption ensures your money and data are protected at every step of your international journey.
          </p>

          <div className="features-list">
            <div className="feature-item">
              <div className="feature-icon">🛡️</div>
              <div className="feature-content">
                <h3>Bank-grade Encryption</h3>
                <p>256-bit AES protection for all your transactions.</p>
              </div>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">👁️</div>
              <div className="feature-content">
                <h3>Real-time Visibility</h3>
                <p>Track your funds from dispatch to delivery.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="login-right">
          <h2 className="form-title">Login or Sign Up</h2>
          <p className="form-subtitle">Choose your preferred method to continue.</p>

          <div className="social-buttons">
            <button className="social-btn google-btn">
              <span className="social-icon">G</span>
              <span>Continue with Google</span>
            </button>
            <button className="social-btn apple-btn">
              <span className="social-icon">🍎</span>
              <span>Continue with Apple</span>
            </button>
          </div>

          <div className="divider">
            <span>OR USE EMAIL</span>
          </div>

          {step === 'credentials' ? (
            <form onSubmit={handleCredentialsSubmit} className="login-form">
              <div className="form-group">
                <label>EMAIL ADDRESS</label>
                <input
                  type="email"
                  className="form-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="name@company.com"
                  required
                />
              </div>

              <div className="form-group">
                <label>PASSWORD</label>
                <input
                  type="password"
                  className="form-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                />
              </div>

              <button type="submit" className="submit-btn">
                Log In
              </button>
            </form>
          ) : (
            <form onSubmit={handleOtpSubmit} className="login-form otp-form">
              <p className="otp-desc">Enter the 6 digit OTP sent to your email.</p>
              <div className="otp-inputs">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    inputMode="numeric"
                    maxLength={6}
                    className="form-input otp-digit"
                    value={digit}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyDown={(e) => handleOtpKeyDown(index, e)}
                    autoFocus={index === 0}
                  />
                ))}
              </div>
              <button type="submit" className="submit-btn">
                Verify OTP
              </button>
              <button type="button" className="btn-back-credentials" onClick={() => setStep('credentials')}>
                Back to login
              </button>
            </form>
          )}

          <p className="signup-link">
            Don't have an account? <Link to="/signup">Sign Up</Link>
          </p>

          <p className="terms-text">
            By continuing, you agree to Connect Lane's <Link to="#">Terms of Service</Link> and <Link to="#">Privacy Policy</Link>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
